import { render, staticRenderFns } from "./Gckfiles.vue?vue&type=template&id=6abfbb58&scoped=true"
import script from "./Gckfiles.vue?vue&type=script&lang=js"
export * from "./Gckfiles.vue?vue&type=script&lang=js"
import style0 from "./Gckfiles.vue?vue&type=style&index=0&id=6abfbb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abfbb58",
  null
  
)

export default component.exports